import { createSlice } from '@reduxjs/toolkit'
// import { OrganizationResponseTypes } from '../../../types/organization.type'

// general imports
import {
  ApiRequestDataType,
  ApiRequestStatus,
  StoredErrorResponseType,
} from '../../../types/api/api.types'
import { getIndividualAccountsThunk } from '../thunks/individual.thunk'
import { IndividualAccountType } from '../../../types/individual.type'

export type getIndividualAccountsState = {
  // eslint-disable-next-line
  requestResponse: ApiRequestDataType<any>
  individualAccounts: IndividualAccountType[]
}

export const initialState: getIndividualAccountsState = {
  requestResponse: {
    status: ApiRequestStatus.IDLE,
    data: null,
  },
  individualAccounts: [] as IndividualAccountType[],
}

const getIndividualAccountsSlice = createSlice({
  name: 'getIndividualAccountsSlice',
  initialState: initialState,
  reducers: {
    resetIndividualAccountsState: (state) => {
      ;(state.requestResponse.status = ApiRequestStatus.IDLE), (state.requestResponse.data = null)
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getIndividualAccountsThunk.pending, (state) => {
        state.requestResponse.status = ApiRequestStatus.PENDING
        state.requestResponse.data = null
        state.requestResponse.error = {} as StoredErrorResponseType
      })
      .addCase(getIndividualAccountsThunk.fulfilled, (state, action) => {
        state.requestResponse.status = ApiRequestStatus.FULFILLED
        // Handle null or undefined payload gracefully
        state.requestResponse.data = action.payload?.content || null
        state.individualAccounts = action.payload?.content || []
      })
      .addCase(getIndividualAccountsThunk.rejected, (state, action) => {
        state.requestResponse.status = ApiRequestStatus.REJECTED
        state.requestResponse.error = action.payload as StoredErrorResponseType
      })
  },
})

export const { resetIndividualAccountsState } = getIndividualAccountsSlice.actions
export default getIndividualAccountsSlice.reducer
